import { render } from "./CardAvgTimeChart.vue?vue&type=template&id=b959a4d0"
import script from "./CardAvgTimeChart.vue?vue&type=script&lang=js"
export * from "./CardAvgTimeChart.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__